import React from 'react';

import {
  Certification,
  CertificationImage,
  CustomCertification,
  CustomCertificationImg,
  Flag,
} from '../../styled/ProductCard/wrapper';

interface ICommunicationResolver {
  slot: Slot | null;
  size: 'small' | 'large';
}

export const CommunicationResolver = ({ slot, size }: ICommunicationResolver) => {
  if (!slot) {
    return null;
  }

  switch (slot.type) {
    case 'banner':
      return (
        <Flag bg={slot.backgroundColor} textColor={slot.textColor} className={size}>
          {slot.title}
        </Flag>
      );

    case 'customCertification':
      return (
        <Flag bg={slot.backgroundColor} textColor={slot.textColor} className={size}>
          {slot.title ?? (
            <CustomCertification>
              <CustomCertificationImg src={slot.source} />
            </CustomCertification>
          )}
        </Flag>
      );

    case 'certificationImage':
      return (
        <Certification className={size}>
          <CertificationImage src={slot.source} />
        </Certification>
      );
    default:
      return null;
  }
};
